import { GoogleAuthProvider } from './google'
import { MSAuthProvider } from './microsoft'

export const providers = {
  google: GoogleAuthProvider,
  microsoft: MSAuthProvider
}
